export const locale = {
    lang: 'pl',
    data: {
        'Details': 'Szczegóły',
        'Logs': 'Logi',
        'Description': 'Opis',
        'Severity': 'Poziom',
        'Created at': 'Data',
        'Created by': 'Utworzył',
        'Actions': 'Akcje',
    }
};
